import React from "react";
import * as Styled from "../styles";
import FormSection from "../../../../../components/FormSelection";
import { TextInput } from "../../../../../components";
import { AdditionalInformationSectionPropTypes } from "../types";
import { RESULTS_MAIN_FORM } from "../const";
import { FileInput } from "../../../../../components/FileInput";
import { Checkbox } from "../../../../../components/CheckBox";
import FormSubtitle from "../../../../../components/FormSubtitle";
import { STUDY_RESULT } from "../../../../../components/ResultsForm/const";

export const AdditionalInformationSection = ({
  resultInfo,
  updateResultInfoHandler,
  checkboxInputHandler,
  fileHandler,
  removeFileHandler,
  currentFile,
  errors,
}: AdditionalInformationSectionPropTypes) => (
  <FormSection
    title={RESULTS_MAIN_FORM.INFORMATION.TITLE}
    subText={RESULTS_MAIN_FORM.INFORMATION.DESCRIPTION}
  >
    <Styled.FormChildrenWrapper>
      <TextInput
        label={RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_URL.LABEL}
        description={
          RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_URL.DESCRIPTION
        }
        placeholder={
          RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_URL.PLACEHOLDER
        }
        setTextValue={(value) =>
          updateResultInfoHandler(
            RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_URL.NAME,
            value
          )
        }
        textValue={resultInfo.resource_website_url || ""}
        theme="form"
        isRequired={false}
        error={errors?.resource_website_url}
      />

      <TextInput
        label={RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_NAME.LABEL}
        description={
          RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_NAME.DESCRIPTION
        }
        descriptionSecondary={
          RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_NAME.DESCRIPTION2
        }
        placeholder={
          RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_NAME.PLACEHOLDER
        }
        setTextValue={(value) =>
          updateResultInfoHandler(
            RESULTS_MAIN_FORM.INFORMATION.INPUTS.WEBSITE_NAME.NAME,
            value
          )
        }
        textValue={resultInfo.resource_website_name || ""}
        theme="form"
        isRequired={false}
        error={errors?.resource_website_name}
      />

      <FileInput
        label={RESULTS_MAIN_FORM.INFORMATION.INPUTS.DOCUMENT.LABEL}
        description={RESULTS_MAIN_FORM.INFORMATION.INPUTS.DOCUMENT.DESCRIPTION}
        handleChange={fileHandler}
        currentFile={currentFile}
        fileName={resultInfo.resource_file_name}
        handleRemoveFile={removeFileHandler}
        // handleGetSignedURl={handleGetSignedURl}
        field={RESULTS_MAIN_FORM.INFORMATION.INPUTS.DOCUMENT.NAME}
        isRequired={false}
        error={errors?.resource_file_name}
      />
    </Styled.FormChildrenWrapper>
    <Styled.SectiontWrapper style={{ marginTop: "40px" }}>
      <FormSubtitle
        subtitle={STUDY_RESULT.RESOURCES.SHARE_ON_HMC.TITLE}
        margin="small"
        link={{
          label: STUDY_RESULT.RESOURCES.SHARE_ON_HMC.LINK.LABEL,
          url: STUDY_RESULT.RESOURCES.SHARE_ON_HMC.LINK.URL,
        }}
      />
      <Styled.FormDescriptionStyles>
        <p
          style={{
            fontSize: "0.875rem",
            fontFamily:
              'Mulish, "Helvetica Neue", Arial, Helvetica, sans-serif',
            fontWeight: "font-weight: 400",
            color: "black",
            lineHeight: "1.33rem",
          }}
        >
          Health Metadata Commons serves as a free centralized hub for storing
          and disseminating metadata pertaining to human biological samples and
          omics research data.{" "}
        </p>
        <p
          style={{
            fontWeight: "bold",
            fontSize: "0.78rem",
            marginTop: "25px",
            lineHeight: "1.1rem",
          }}
        >
          **Please note that consenting to also share the study results on HMC{" "}
          {/* eslint-disable react/no-unescaped-entities */}
          indicates that you've obtained Principal Investigator (PI)'s
          approval.**
        </p>
      </Styled.FormDescriptionStyles>
      <Styled.FlexBoxStyled>
        <Checkbox
          label={STUDY_RESULT.RESOURCES.SHARE_ON_HMC.CHECKBOX_LABEL}
          isChecked={resultInfo.share_on_hmc || false}
          onChange={() =>
            checkboxInputHandler("share_on_hmc", !resultInfo.share_on_hmc, "")
          }
          labelTheme="secondary"
          textTransform="none"
        />
      </Styled.FlexBoxStyled>
    </Styled.SectiontWrapper>
  </FormSection>
);
